import type {Duration} from "date-fns";
import type {SbRichTextDoc as ISbRichtext} from "@storyblok/js";

import {richTextToString} from "../utils/rich-text-to-string";

export interface ReadingTimeOptions {
	readingSpeedWpm: number;
}

const defaultReadingTimeOptions: ReadingTimeOptions = {
	readingSpeedWpm: 200,
};

const parseWordsFromContent = (
	content: ISbRichtext | string | null | undefined,
) => {
	try {
		const text = richTextToString(content);

		if (!text) {
			return [];
		}

		const words = text.trim().split(/\s+/);
		return words;
	} catch {
		return [];
	}
};

export function useReadingTime(
	// SB rich text or HTML
	content: ISbRichtext | string | null | undefined,
	options: ReadingTimeOptions = defaultReadingTimeOptions,
) {
	const words = parseWordsFromContent(content);
	const {readingSpeedWpm: readingSpeed} = options;
	const timeInMinutes = words.length > 0 ? words.length / readingSpeed : 0;

	return {
		estimatedReadingTime: {
			// Reading time should always start from one minute
			minutes:
				timeInMinutes > 0 && timeInMinutes < 1 ? 1 : Math.round(timeInMinutes),
		} as Duration,
		wordCount: words.length,
	};
}
